<div class="pef-sheet-wrapper">
  <table class="pef-table">
    <colgroup>
      <col class="pef-col-label" />
      @for (col of columns(); track col.id) {
        <col [style.width.px]="col.widthPx ?? 110" />
      }
    </colgroup>

    <thead>
      <tr class="pef-row pef-row--header">
        <th class="pef-th pef-th--label"></th>
        @for (col of columns(); track col.id) {
          <th class="pef-th pef-th--data">
            {{ col.label }}
            @if (!col.standalone && !readonly()) {
              <button
                class="pef-autofill-col-btn"
                [class.pef-autofill-col-btn--active]="activeColumnId() === col.id"
                (click)="openColumnMenu(col.id, $event)"
                title="Autofill da questa colonna"
              >
                <i class="pi pi-copy"></i>
              </button>
            }
          </th>
        }
      </tr>
    </thead>

    <tbody>
      @for (row of rows(); track row.id) {
        @if (row.type === 'spacer') {
          <tr class="pef-row pef-row--spacer">
            <td [attr.colspan]="columns().length + 1"></td>
          </tr>
        } @else if (row.type === 'section-header') {
          <tr [class]="rowClass(row.type)">
            <td class="pef-td pef-td--section-label" [attr.colspan]="columns().length + 1">
              <span class="pef-td--section-label-inner">{{ row.label }}</span>
            </td>
          </tr>
        } @else {
          <tr [class]="rowClass(row.type)" (contextmenu)="onRowContext($event, row)">
            <td
              class="pef-td pef-td--label"
              [class.pef-td--label-editable]="!!row.labelInputKey"
              [class.pef-td--dirty]="isLabelDirty(row)"
            >
              @if (row.labelInputKey && !readonly()) {
                <input
                  class="pef-label-input"
                  [ngModel]="labelValue(row)"
                  (ngModelChange)="onLabelChange(row, $event)"
                  [placeholder]="row.label"
                />
              } @else {
                <div class="pef-td-label-inner">
                  <span>{{ row.labelInputKey ? labelValue(row) || row.label : row.label }}</span>
                  @if (rowHasInputCells(row) && !readonly()) {
                    <span class="pef-autofill-row-actions">
                      <button
                        class="pef-autofill-row-btn"
                        (click)="onRowFill(row.id)"
                        title="Estendi il valore su tutti gli anni"
                      >
                        <i class="pi pi-arrows-h"></i>
                      </button>
                      <button
                        class="pef-autofill-row-btn"
                        [class.pef-autofill-row-btn--active]="progFill()?.activeRowId() === row.id"
                        (click)="progFill()?.open(row.id, $event)"
                        title="Riempimento progressivo"
                      >
                        <i class="pi pi-chart-line"></i>
                      </button>
                    </span>
                  }
                </div>
              }
            </td>
            @for (col of columns(); track col.id) {
              @let cell = resolveCell(row, col.id);
              <td
                class="pef-td pef-td--data"
                [class.pef-td--input]="cell.type === 'input'"
                [class.pef-td--calculated]="cell.type === 'calculated'"
                [class.pef-td--dirty]="isCellDirty(row, col.id)"
                [attr.colspan]="cell.colspan ?? null"
                [attr.rowspan]="cell.rowspan ?? null"
              >
                @if (cell.type !== 'empty') {
                  <lib-pef-cell
                    [cell]="cell"
                    [value]="cellValue(row, col.id)"
                    [loading]="loading()"
                    [readonly]="readonly()"
                    (valueChange)="cellValueChange.emit($event)"
                  />
                }
              </td>
            }
          </tr>
        }
      }
    </tbody>
  </table>
</div>

<p-popover #colMenu (onHide)="activeColumnId.set(null)">
  <div class="pef-autofill-menu">
    <button class="pef-autofill-menu-item" (click)="onColumnAutofillToAll()">
      <i class="pi pi-arrow-right"></i>
      Copia su tutte le colonne
    </button>
    @if (activeColumnOtherCols().length > 0) {
      <hr class="pef-autofill-menu-divider" />
      @for (col of activeColumnOtherCols(); track col.id) {
        <button class="pef-autofill-menu-item" (click)="onColumnAutofillToColumn(col.id)">
          <i class="pi pi-arrow-right"></i>
          Copia su {{ col.label }}
        </button>
      }
    }
  </div>
</p-popover>

<lib-pef-progressive-fill [sheet]="sheet()" (apply)="autofill.emit($event)" />

<p-contextmenu #rowMenu [model]="rowMenuItems()" appendTo="body" />
